import { ContextWrapper } from "@common/contexts";
import { IntakePetStore } from "@customer/stores";

export const IntakePetStoreContextWrapper = new ContextWrapper<IntakePetStore>();
